var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "80px",
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.customerList,
                            placeholder: _vm.$t("customerNameText"),
                          },
                          on: { change: _vm.changeCustomer },
                          model: {
                            value: _vm.cusName,
                            callback: function ($$v) {
                              _vm.cusName = $$v
                            },
                            expression: "cusName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "cusCode" } },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: 20,
                            placeholder: _vm.$t("billingPage.clientCode"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.cusCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "cusCode", $$v)
                            },
                            expression: "queryParams.cusCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "WarehouseManagement.form.chooseLogistics"
                          ),
                          prop: "logisticsName",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.LogisticsSelectionData,
                            placeholder: _vm.$t(
                              "WarehouseManagement.form.chooseLogistics"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.logisticsName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "logisticsName", $$v)
                            },
                            expression: "queryParams.logisticsName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("AccountManagementAdd.from") } },
                      [
                        _c("BjDateRangePicker", {
                          attrs: {
                            placeholder: _vm.$t("AccountManagementAdd.ps2"),
                          },
                          model: {
                            value: _vm.queryParamsTime_create,
                            callback: function ($$v) {
                              _vm.queryParamsTime_create = $$v
                            },
                            expression: "queryParamsTime_create",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "isEnable" } },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.STATUS_ENABLED_NUM,
                            placeholder: _vm.$t("RoleManagement.common.Status"),
                          },
                          model: {
                            value: _vm.queryParams.isEnable,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "isEnable", $$v)
                            },
                            expression: "queryParams.isEnable",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.addRate(1)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("addText")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "isEnable"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: scope.row.isEnable
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.STATUS_ENABLED_NUM.bjGet(
                                                      scope.row.isEnable
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : col.prop === "profitMargin"
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(scope.row.profitMargin) + "%"
                                          ),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addRate(2, props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                    !props.row.isEnable
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "delete-btn",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onEnable(props.row)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("enableText")))]
                                        )
                                      : _vm._e(),
                                    props.row.isEnable
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "delete-btn",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onDisable(props.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("disableText"))
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showLog(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("logText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("DataForm", {
        ref: "DataForm",
        on: { reFresh: _vm.reFresh, batchDeleteApi: _vm.batchDeleteApi },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }